export const uncheckAllIds = [
    "full_body",
    "no",
    "dontKnow",
    "none",
    "dont_know",
    "dont_struggle",
    "prefer_not_to_answer",
    "not_planning",
    "none_yet",
    "other",
];

export const getCheckedItems = (id: string, checked: string[]) => {
    if (uncheckAllIds.includes(id)) {
        if (checked.includes(id)) {
            return [];
        }
        return [id];
    }
    if (checked.includes(id)) {
        return checked.filter((item) => item !== id);
    } else {
        return checked?.length ? [...checked.filter((i) => !uncheckAllIds.includes(i)), id] : [id];
    }
};
